export const LOCATION_TYPES = {
  HOME: 'home',
};
